import axios from "axios";
import { SIGNUP_URL } from "src/constants";

export const signup = (data) => {
  return axios.post(SIGNUP_URL, data);
};
